exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-gallery-overlay[data-v-6c8b77cc]{width:18px}@media only screen and (min-device-width: 768px) and (max-device-width: 1024px){.close-gallery-overlay[data-v-6c8b77cc]{width:26px}}.media-zoom[data-v-6c8b77cc]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:4;background:#fff}.media-zoom__close[data-v-6c8b77cc]{position:absolute;right:0;top:0;z-index:1}@media only screen and (min-device-width: 768px) and (max-device-width: 1024px), (max-width: 767px){.media-zoom__close[data-v-6c8b77cc]{bottom:0;top:unset}}\n", ""]);

// exports
